import React, { useEffect, useState } from "react";
import { Col, Row, message } from "antd";
import SubLayout from "../../components/layout/SubLayout";
import OnboardingLayout from "../../components/layout/OnboardingLayout";
import { OnBoardingProgress } from "../../components/common/campaignManagement/SectionProgress";
import OnboardingForm from "../../components/common/Onboarding/OnboardingForm";
import ChoosePlan from "../../components/common/Onboarding/ChoosePlan";
import Adduser from "../../components/common/Onboarding/Adduser";
import ReviewAndPay from "../../components/common/Onboarding/ReviewAndPay";
import API_MANAGER from "../../API";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const parseOfficeAddress = (address) => {
  if (!address) {
    return {
      street: "",
      city: "",
      state: "",
      postcode: "",
      country: "AU",
    };
  }

  if (typeof address === "object" && (address.street || address.city)) {
    return {
      street: address.street || "",
      city: address.city || "",
      state: address.state || "",
      postcode: address.postcode || address.postalCode || "",
      country: address.country || "AU",
    };
  }

  const label =
    typeof address === "string"
      ? address
      : address?.label ||
        address?.description ||
        address?.value?.description ||
        "";

  const match = label.match(/^(.+?)\s+([A-Z]{2,3})\s+(\d{4})(?:,\s*.*)?$/);
  if (match) {
    return {
      street: label,
      city: match[1].trim(),
      state: match[2],
      postcode: match[3],
      country: "AU",
    };
  }

  return {
    street: label,
    city: "",
    state: "",
    postcode: "",
    country: "AU",
  };
};

function CreateAccount() {
  const navigate = useNavigate();
  const [progress, setprogress] = useState({
    first: 0,
    second: 0,
    third: 0,
    forth: 0,
  });
  const [formProgress, setformProgress] = useState({
    marketingPermission: false,
  });
  const [currentForm, setcurrentForm] = useState("onboarding");
  const [onboardData, setOnboardData] = useState([]);
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [editLogo, setEditLogo] = useState(false);
  const [addUserData, setAddUserData] = useState({
    account: 0,
    association: 0,
  });
  const [formNextLoading, setFormNextLoading] = useState(false);
  const [userData, setUserData] = useState({});
  const [payLoading, setPayLoading] = useState(false);
  const [discountCode, setDiscountCode] = useState(null);
  const [status, setStatus] = useState({
    company: "progress",
    plan: "wait",
    user: "wait",
    pay: "wait",
  });

  const getSubscriptionData = async () => {
    try {
      const response = await API_MANAGER.getSubscriptionData();
      setSubscriptionData(response?.data?.data);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };

  const checkCreateAccountAccess = async () => {
    try {
      const response = await API_MANAGER.getSwitchUserList();
      const accounts = Array.isArray(response?.data?.data)
        ? response.data.data
        : Array.isArray(response?.data)
          ? response.data
          : [];
      const hasOwnerAccount = accounts.some((item) => item?.isOwner === true);
      if (hasOwnerAccount) {
        navigate(-1);
      }
    } catch (error) {
      navigate(-1);
    }
  };

  useEffect(() => {
    checkCreateAccountAccess();
    getSubscriptionData();
  }, []);

  const uploadCompanyLogo = async (uploadLogo) => {
    if (!(uploadLogo?.length > 0 && typeof uploadLogo[0] === "object")) {
      return "";
    }
    const dataLogo = {
      extension: uploadLogo[0]?.type?.split("/")[1] || "",
      type: "PROFILE",
      contentType: uploadLogo[0]?.type || "",
    };
    const responseLogo = await API_MANAGER.fileUpload(dataLogo);
    if (responseLogo) {
      await axios.put(
        responseLogo?.data?.data?.url,
        uploadLogo[0]?.originFileObj
      );
    }
    return responseLogo?.data?.data?.key || "";
  };

  const hadelFormFilled = async (e, type) => {
    if (type !== "onboard") return;

    setOnboardData(e);
    setFormNextLoading(true);

    try {
      const companyLogo = await uploadCompanyLogo(e?.upload_logo);
      const billingEmail =
        formProgress?.billingEmail || e?.billingEmail || "";
      const params = {
        companyName: formProgress?.companyName || e?.companyName || "",
        tradingName: formProgress?.tradingName || e?.tradingName || "",
        companyAbn: formProgress?.companyAbn || e?.companyAbn || "",
        companyLogo,
        officeAddress: parseOfficeAddress(
          formProgress?.registered_address || e?.registered_address
        ),
        billingName: formProgress?.billingName || e?.billingName || "",
        officialEmail:
          localStorage.getItem("userEmail") || billingEmail || "",
        billingEmail,
        marketingPermission: !!(
          formProgress?.marketingPermission ?? e?.marketingPermission
        ),
      };

      if (!params.tradingName || params.tradingName.trim() === "") {
        delete params.tradingName;
      }

      const response = await API_MANAGER.createRootAccount(params);
      if (response?.data?.data?._id) {
        const newAccount = response.data.data;
        localStorage.setItem("clientId", newAccount._id);
        localStorage.setItem("user", "Root");
        localStorage.setItem("permissions", JSON.stringify([0, 1, 2, 3]));
        
        if (newAccount?.userId?.subscription?.[0]?.sp?.plusSubscription) {
          localStorage.setItem(
            "isPlusSubscription",
            newAccount.userId.subscription[0].sp.plusSubscription
          );
        } else {
          localStorage.setItem("isPlusSubscription", false);
        }
        
        if (newAccount?.userId?.subscription?.length > 0) {
          localStorage.setItem(
            "subscription",
            JSON.stringify(newAccount.userId.subscription[0])
          );
        } else {
          localStorage.setItem("subscription", JSON.stringify({}));
        }
      }

      setStatus((prev) => ({
        ...prev,
        company: "success",
        plan: "progress",
      }));
      setprogress((prev) => ({ ...prev, first: 100 }));
      setcurrentForm("plan");
    } catch (error) {
      message.error(
        error?.response?.data?.message?.message ||
          error?.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setFormNextLoading(false);
    }
  };

  const handleSubmit = async () => {
    setPayLoading(true);
    try {
      const paramData = {
        priceId: selectedPlan?.product_price,
        subscriptionProductId: selectedPlan?._id,
        accountUser: selectedPlan?.standard_users,
        associateUser: selectedPlan?.association_users,
        billingEmail: formProgress?.billingEmail,
        additionalData: [
          {
            title: "Additional Association Users",
            price: selectedPlan?.additional_association_user_price,
            quantity: addUserData?.association,
            userType: "associate",
          },
          {
            title: "Additional Account Users",
            price: selectedPlan?.additional_standard_user_price,
            quantity: addUserData?.account,
            userType: "account",
          },
        ],
      };
      if (discountCode) {
        paramData["discount"] = discountCode;
      }
      const subscriptionResponse = await API_MANAGER.addSubscription(paramData);
      localStorage.setItem("isStripe", "yes");
      setPayLoading(false);
      window.open(subscriptionResponse?.data?.data, "_self");
    } catch (error) {
      setPayLoading(false);
      message.error(
        error?.response?.data?.message?.message ||
          "Something went wrong. Please try again."
      );
    }
  };

  const handleDelete = () => {
    setSelectedPlan({});
    setAddUserData({
      account: 0,
      association: 0,
    });
    setprogress({
      first: 100,
      second: 0,
      third: 0,
      forth: 0,
    });
    setStatus({
      company: "success",
      plan: "progress",
      user: "wait",
      pay: "wait",
    });
    setcurrentForm("plan");
  };

  return (
    <OnboardingLayout whiteBg>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          height: "100vh",
        }}
      >
        <SubLayout page={"Create Account"} showBack>
          <div className="onboarding_form_container">
            <Row>
              <Col xs={24} md={0} className="Onboarding-sm">
                Create Account
              </Col>
            </Row>
            <Row className="onboarding-progress-container">
              <OnBoardingProgress
                percent={progress}
                status={status}
                setcurrentForm={setcurrentForm}
              />
            </Row>
            {currentForm === "onboarding" && (
              <Row className="w-100">
                <OnboardingForm
                  setprogress={setprogress}
                  setStatus={setStatus}
                  handelFinish={hadelFormFilled}
                  formProgress={formProgress}
                  setformProgress={setformProgress}
                  onboardData={onboardData}
                  setOnboardData={setOnboardData}
                  userData={userData}
                  setcurrentForm={setcurrentForm}
                  loading={formNextLoading}
                  setEditLogo={setEditLogo}
                  editLogo={editLogo}
                />
              </Row>
            )}
            {currentForm === "plan" && (
              <ChoosePlan
                setcurrentForm={setcurrentForm}
                setprogress={setprogress}
                setStatus={setStatus}
                handelFinish={hadelFormFilled}
                setSelectedPlan={setSelectedPlan}
                selectedPlan={selectedPlan}
                data={subscriptionData}
                userData={userData}
              />
            )}
            {currentForm === "add user" && (
              <Adduser
                setcurrentForm={setcurrentForm}
                setprogress={setprogress}
                setStatus={setStatus}
                handelFinish={hadelFormFilled}
                setAddUserData={setAddUserData}
                addUserData={addUserData}
                data={selectedPlan}
                userData={userData}
              />
            )}
            {currentForm === "pay" && (
              <ReviewAndPay
                handleSubmit={handleSubmit}
                data={selectedPlan}
                addUserData={addUserData}
                setAddUserData={setAddUserData}
                handleDelete={handleDelete}
                loading={payLoading}
                setLoading={setPayLoading}
                setDiscountCode={setDiscountCode}
                discountCode={discountCode}
              />
            )}
          </div>
        </SubLayout>
      </div>
    </OnboardingLayout>
  );
}

export default CreateAccount;
